import * as atlas from 'azure-maps-control';

export class CustomControl implements atlas.Control {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  onAdd(): HTMLElement {
    return this.container;
  }

  onRemove(): void {
    if (this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }
}
